import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

export default function AddressAutocomplete() {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const fetchSuggestions = async (value) => {
    try {
        const params = new URLSearchParams({
          key: '240545036247499792',
          prefix: inputValue
      });

      const response = await fetch(`https://us-autocomplete-pro.api.smarty.com/lookup?${params}`);
      const data = await response.json();

      if (data.suggestions) {
        setSuggestions(data.suggestions.map(s => s.text));
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error('Autocomplete fetch failed:', error);
      setSuggestions([]);
    }
  };

  const handleChange = (event) => {
    const value = event.target.value;
    setInputValue(value);
    if (value.length > 2) {
      fetchSuggestions(value);
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (address) => {
    setInputValue(address);
    setSuggestions([]);
    // Optional: trigger validation after selection
  };

  return (
    <FormControl sx={{ width: { xs: '100%', md: '50ch' } }} variant="outlined">
      <OutlinedInput
        size="small"
        placeholder="Enter Address…"
        value={inputValue}
        onChange={handleChange}
        startAdornment={
          <InputAdornment position="start" sx={{ color: 'text.primary' }}>
            <SearchRoundedIcon fontSize="small" />
          </InputAdornment>
        }
        inputProps={{ 'aria-label': 'search' }}
      />
      {suggestions.length > 0 && (
        <List sx={{ border: '1px solid #ccc', borderRadius: '4px', mt: 1, bgcolor: '#fff' }}>
          {suggestions.map((address, index) => (
            <ListItem
              button
              key={index}
              onClick={() => handleSelect(address)}
            >
              {address}
            </ListItem>
          ))}
        </List>
      )}
    </FormControl>
  );
}

